import request from '@/utils/request'
import { API } from './apiConfig'

export function getNewVisitItem(data) {
  return request({
    url: API.getNewVisitItem,
    method: 'get',
    params: data
  })
}

export function submitNewExam(data) {
  return request({
    url: API.submitNewExam,
    method: 'post',
    data: data
  })
}